export const stripHtml = htmlString => {
   const tmp = document.createElement("div")
   tmp.innerHTML = htmlString
   return tmp.textContent || tmp.innerText || ""
}
